import Component from '../core/Component'
import { triggerEvent } from '../utils/dom'

export const STATUS = {
    VISIBLE: 'is-visible'
}

export default class CalendarFormRegistration extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            date: null,
            newDonor: null
        }
    }

    prepare() {
        if (this.ref.newDonor) {
            this.ref.newDonor.addEventListener('change', ::this.handleNewDonorChange)
            this.refreshDateSelect()
        }

    }

    handleNewDonorChange() {
        this.refreshDateSelect()
    }

    refreshDateSelect() {
        Array.from(this.ref.date.options)
            .forEach(element => {
                if (this.ref.newDonor.checked) {
                    element.disabled = (element.dataset.newDonor == null)
                } else {
                    element.disabled = (element.dataset.newDonor != null)
                }
            })

        const available = this.ref.date.querySelector('option:not(:disabled)')

        if (available) {
            this.ref.date.disabled = false
            this.ref.date.selectedIndex = Array.from(this.ref.date.options).indexOf(available)
        } else {
            this.ref.date.disabled = true
        }
    }

    setValue(name, value) {
        switch (name) {
            case 'date':
                if (this.ref.date) {
                    if (this.ref.newDonor) {
                        const option = this.ref.date.querySelector(`option[value="${value}"]`)
                        this.ref.newDonor.checked = (option.dataset.newDonor != null)
                        triggerEvent(this.ref.newDonor, 'change')
                    }

                    this.ref.date.value = value
                    triggerEvent(this.ref.date, 'change')
                }
            break
        }
    }

    show() {
        this.element.classList.add(STATUS.VISIBLE)
        return this
    }
}